<span class="copy-icon" *ngIf="data?.[commentKey]" (click)="copyText(data?.[commentKey], data)">
    <i class="fa fa-clone" type="button" aria-hidden="true" *ngIf="!data.copied" title="Copy Text"></i>
    <i class="fa fa-check" type="button" aria-hidden="true" *ngIf="data.copied" title="Copied"></i>
</span>